/** The GuruPay setting that decides whether Norvix commissions are moved (DEV-127). */
export const COMMISSION_TRANSFER_MODE_KEY = 'commissionTransferMode';
